import React from "react";
import ShopResetPassword from "../components/Shop/ShopResetPassword";

const ShopResetPasswordPage = () => {
  return (
    <div>
      <ShopResetPassword />
    </div>
  );
};

export default ShopResetPasswordPage;
